import { ApolloClient, ApolloLink, InMemoryCache } from "@apollo/client";
//@ts-ignore
import createUploadLink from "apollo-upload-client/createUploadLink.mjs";
import * as Sentry from "@sentry/react";

export function createApolloClient(endpoint: string) {
  // Create Sentry tracing link for Apollo
  const sentryLink = new ApolloLink((operation, forward) => {
    const span = Sentry.startInactiveSpan({
      name: `GraphQL: ${operation.operationName}`,
      op: "graphql.query",
      attributes: {
        "graphql.operation.name": operation.operationName,
        "graphql.operation.type":
          operation.query.definitions[0]?.kind || "unknown",
      },
    });

    return forward(operation).map((result) => {
      span?.end();
      return result;
    });
  });

  const uploadLink = createUploadLink({
    uri: [endpoint, "query"].join("/"),
    fetchOptions: {
      credentials: "include",
    },
  });

  return new ApolloClient({
    cache: new InMemoryCache({
      typePolicies: {
        Organization: {
          fields: {
            socials: {
              merge: true,
            },
          },
        },
      },
    }),
    //@ts-ignore
    link: ApolloLink.from([sentryLink, uploadLink]),
  });
}

export function createDownloadUrl(endpoint: string) {
  return [endpoint, "v1", "files"].join("/");
}
